export function forward(message: Message, listeners: Listeners): void {
  listeners.forEach((listener) => listener.sendMessage(message));
}
